<template>
  <div id="zhAqtIndex">
    <zh-search-class></zh-search-class>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {
  },
  methods: {},
  mounted() {

  }
}
</script>
<style lang="less" scoped>
#zhAqtIndex {
  width: 100%;
  height: 100%;
  display: flex;
  background: #ffffff;
  overflow-x: auto;
  justify-content: center;
}
</style>
